export default __webpack_public_path__ + "static/media/icon-up.9e0e9a4c.svg";